import axios, { AxiosInstance } from 'axios';
import { APIService } from '../types/common';

// creating axios public instance here
const userServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_USER_SERVICE_PROD_API,
});

const appointmentServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_APPOINTMENT_SERVICE_PROD_API,
});

const financeServiceAPI: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_FINANCE_SERVICE_PROD_API,
});

// function to get axios instance based on service declared here
export const getAxiosInstance = (whichService: APIService) => {
  switch (whichService) {
    case 'user':
      return userServiceAPI;

    case 'appointment':
      return appointmentServiceAPI;

    case 'finance':
      return financeServiceAPI;

    default:
      throw new Error('Invalid Service Type!!');
  }
};
